import axios from "axios";
import React, { useContext, useEffect, useState } from "react";
import Cookies from "js-cookie";
import { FetchDataTypes } from "../api/api";
import { Bar } from "react-chartjs-2";
import {
  Chart,
  ArcElement,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
Chart.register(
  ArcElement,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

function HoldingsPercentageTable() {
  const [sectorAllocation, setSectorAllocation] = useState<any>(null);
  const selectedClient:any = Cookies.get("client")
  useEffect(() => {
    FetchDataTypes("HoldingsPercentage", parseInt(selectedClient), Cookies.get("newJwt"))
      .then((response) => response.json())
      .then((response) => {
        setSectorAllocation(response);
      });
  }, []);

  function formateAsPercent(num: any) {
    return new Intl.NumberFormat("default", {
      style: "percent",
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    }).format(num / 5.0);
  }
  function currencyFormat(num: any) {
    return num.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
  }
  return (
    <div className="card w-100">
      <div className="card-header" style={{ paddingBottom: "0px" }}>
        <h5 className="card-title">Holdings Percentage</h5>
      </div>
      <div className="card-body" style={{ paddingTop: "0px" }}>
        <div className="chart chart-xs">
          <div className="chartjs-size-monitor">
            <div className="chartjs-size-monitor-shrink styleScroll">
              <table
                className="table table-striped my-0 table-fixed "
                style={{ height: "400px" }}
              >
                <thead>
                  <tr>
                    <th>Symbol</th>
                    <th className="text-end col-sm-4">Market Value</th>
                    <th className="d-none d-xl-table-cell">
                      Holding Percentage
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {sectorAllocation &&
                    sectorAllocation.map((e: any, index: any) => {
                      return (
                        <tr key={index}>
                          <td>{e.symbol}</td>
                          <td className="text-center">
                            {e.marketValue >= 0
                              ? "$" + currencyFormat(e.marketValue)
                              : "NA"}
                          </td>
                          <td className="d-none d-xl-table-cell">
                            <div className="progress">
                              <div
                                className="progress-bar bg-percentage"
                                style={{
                                  width: formateAsPercent(e.holdingPercentage),
                                }}
                              >
                                {e.holdingPercentage >= 0
                                  ? currencyFormat(e.holdingPercentage) + "%"
                                  : "NA"}
                              </div>
                            </div>
                          </td>
                        </tr>
                      );
                    })}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export { HoldingsPercentageTable };
